import React, { useEffect } from "react";
import DefaultModal from "../DefaultModal/DefaultModal";
import AddBikeForm from "../forms/AddBikeForm/AddBikeForm";
import ModalTitle from "../ModalTitle/ModalTitle";
import styles from "./styles.module.scss";

interface Props {
  onClose: () => void;
  onApply: () => void;
}

const AddBikeModal: React.FC<Props> = (props) => {
  const onApply = () => {
    props.onApply();
    props.onClose();
  };

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        props.onClose();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.onClose]);

  return (
    <DefaultModal>
      <div className={styles.container}>
        <ModalTitle
          onClose={props.onClose}
          title="Додати байк"
          subTitle='Додайте новий байк до системи. Заповніть необхідну інформацію та натисніть "Додати клієнта".'
        ></ModalTitle>
        <AddBikeForm onApply={onApply} onClose={props.onClose} />
      </div>
    </DefaultModal>
  );
};

export default AddBikeModal;
